import { render, staticRenderFns } from "./PanelTemperature.vue?vue&type=template&id=2879cd3a&"
import script from "./PanelTemperature.vue?vue&type=script&lang=js&"
export * from "./PanelTemperature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports